import { Box } from "@mui/material";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";

import Page from "src/components/Page";
import { PATH_DASHBOARD } from "src/routes/paths";
import Retail from "./components/Retail";

const RetailPartner = () => {
  return (
    <Page title="Retail Partner">
      <Box>
        <HeaderBreadcrumbs
          heading="Retail Partner"
          links={[
            { name: "Dashboard", href: PATH_DASHBOARD.root },
            { name: "Retail Partner" },
          ]}
        />
        <Retail />
      </Box>
    </Page>
  );
};

export default RetailPartner;
